import BookedTabList from './QuoteDetailTab/BookedTabList';
import ExpiredTabList from './QuoteDetailTab/ExpiredTabList';
import NoBidTabList from './QuoteDetailTab/NoBidTabList';
import PendingTabList from './QuoteDetailTab/PendingTabList';
import QuoteDetailTabsListing from './QuoteDetailTabsListing';
import ApprovedTabList from './QuoteDetailTab/ApprovedTabList';
import store from "../../storeWire";
import quoteDetailAPICallResponseMaker from "../../service/QuoteDetailAPICall/quoteDetailAPICallResponseMaker";

class CommonQuoteDetail {
    //MainPage
    static chain = {
        QuoteDetailTabsListing: { param_value: 'APR', element: QuoteDetailTabsListing }
    };
    static param_key = '__c';
    static redux_key = 'QuoteDetail__Component__Loader';
    static default_component = CommonQuoteDetail.chain.QuoteDetailTabsListing;
    static chain_QuoteDetailTabList = {
        APR: {
            name: 'APPROVED',
            param_value: 'APR',
            element: ApprovedTabList,
            store: () => {
                return CommonQuoteDetail.getStore('Approved')
            },
        },
        PND: {
            name: 'PENDING',
            param_value: 'PND',
            element: PendingTabList,
            store: () => {
                return CommonQuoteDetail.getStore('Pending')
            },
        },
        NBD: {
            name: 'NO BID',
            param_value: 'NBD',
            element: NoBidTabList,
            store: () => {
                return CommonQuoteDetail.getStore('NoBid')
            },
        },
        BKD: {
            name: 'BOOKED',
            param_value: 'BKD',
            element: BookedTabList,
            store: () => {
                return CommonQuoteDetail.getStore('Booking')
            },
        },
        EXP: {
            name: 'EXPIRED',
            param_value: 'EXP',
            element: ExpiredTabList,
            store: () => {
                return CommonQuoteDetail.getStore('Expired')
            },
        }
    };

    static getStore(slug) {
        let s = store.getState();
        if (s.entities.model_QuoteDetail !== undefined &&
            s.entities.model_QuoteDetail.line_items !== undefined &&
            s.entities.model_QuoteDetail.line_items[slug] !== undefined
        ) {
            return s.entities.model_QuoteDetail.line_items[slug];
        }
        return new quoteDetailAPICallResponseMaker().defaultValue().line_items[slug];
    }


    static param_key_QuoteDetailTabList = '__c_QuoteDetailTabList';
    static redux_key_QuoteDetailTabList = 'QuoteDetailTabList__Component__Loader';
    static default_component_QuoteDetailTabList = CommonQuoteDetail.chain_QuoteDetailTabList.APR;

    static getSelectedQtyStrFromQuoteCartSession(quoteNumber, lineItemNumber, selectedQty) {
        let s = store.getState();

        if (s.entities.model_QuoteDetail.cart_quote_active_session[quoteNumber] !== undefined) {
            const quote = s.entities.model_QuoteDetail.cart_quote_active_session[quoteNumber];
            const qty = quote.records?.[lineItemNumber]?.quantity_field_selected;

            if (qty === selectedQty) {
                return true
            } else {
                return false
            }
        }
        return false;
    }

    static getCurrentActiveTab(cmpLdr) {
        const currentTab = CommonQuoteDetail.chain_QuoteDetailTabList[cmpLdr];
        const tabStore = currentTab.store();
        return tabStore?.api_query_param ? tabStore?.api_query_param : 'A';
    }
    static getCurrentActiveTabSlug(cmpLdr) {
        const currentTab = CommonQuoteDetail.chain_QuoteDetailTabList[cmpLdr];
        const tabStore = currentTab.store();
        return tabStore?.slug ? tabStore?.slug : 'Approved';
    }

    static getCurrentActiveTabDetail(cmpLdr) {
        const currentTab = CommonQuoteDetail.chain_QuoteDetailTabList[cmpLdr];
        const tabStore = currentTab.store();
        return tabStore;
    }


    static validateQtyMinMult = (selectedQty, qtyMult, qtyMin) => {
        if (qtyMin !== undefined && selectedQty < qtyMin) {
            return false;
        }
        if (qtyMult !== undefined && selectedQty % qtyMult !== 0) {
            return false;
        }
        return true;
    };

    static disableQtyChk(qty,lineItem) {
        let s = store.getState();


        if (s.entities.model_QuoteDetail.cart_quote_active_session[quoteNumber] !== undefined) {
            const quote = s.entities.model_QuoteDetail.cart_quote_active_session[quoteNumber];
            const qty = quote.records?.[lineItemNumber]?.quantity_field_selected;


            if (qty === selectedQty) {
                return true
            } else {
                return false
            }
        }
        return false;
    }
}

export default CommonQuoteDetail;